import {CacheJsService} from './cache-js.service';
import {ConfiguratorCallInvoicesService} from './configuratorCallInvoices.service';
import {ConfiguratorCommandOrderService} from './configuratorCommandOrder.service';
import {ConfiguratorConfigurationService} from './configuratorConfiguration.service';
import {ConfiguratorContactService} from './configuratorContact.service';
import {ConfiguratorCompanyService} from './configuratorCompany.service';
import {ConfiguratorDataViewService} from './configuratorDataView.service';
import {ConfiguratorDatastoreService} from './configuratorDatastore.service';
import {ConfiguratorEtlService} from './configuratorEtl.service';
import {ConfiguratorI18nCacheService} from './configuratorI18nCache.service';
import {ConfiguratorI18nService} from './configuratorI18n.service';
import {ConfiguratorLandingPageService} from './configuratorLandingPage.service';
import {ConfiguratorNewsletterService} from './configuratorNewsletter.service';
import {ConfiguratorPageHtml5Service} from './configuratorPageHtml5.service';
import {ConfiguratorPingService} from './configuratorPing.service';
import {ConfiguratorProviderService} from './configuratorProvider.service';
import {ConfiguratorPublicLandingPageService} from './configuratorPublicLandingPage.service';
import {ConfiguratorPublicNewsletterService} from './configuratorPublicNewsletter.service';
import {ConfiguratorPublicUpdateService} from './configuratorPublicUpdate.service';
import {ConfiguratorSaveQueryService} from './configuratorSaveQuery.service';
import {ConfiguratorUserUiPreferenceService} from './configuratorUserUiPreference.service';
import {ConfiguratorScenarioService} from './configuratorScenario.service';
import {ConfiguratorScriptService} from './configuratorScript.service';
import {ConfiguratorSendInBlueService} from './configuratorSendInBlue.service';
import {ConfiguratorStatisticsCacheService} from './configuratorStatisticsCache.service';
import {ConfiguratorStructureService} from './configuratorStructure.service';
import {ConfiguratorTableService} from './configuratorTable.service';
import {ConfiguratorTaskService} from './configuratorTask.service';
import {ConfiguratorTemplateHtmlService} from './configuratorTemplateHtml.service';
import {ConfiguratorFileConnectionService} from './configuratorFileConnection.service';
import {ConfiguratorTenantConfigurationService} from './configuratorTenantConfiguration.service';
import {ConfiguratorTenantService} from './configuratorTenant.service';
import {ConfiguratorTokenService} from './configuratorToken.service';
import {ConfiguratorTraductionService} from './configuratorTraduction.service';
import {ConfiguratorTransactionalEmailService} from './configuratorTransactionalEmail.service';
import {ConfiguratorValidatorService} from './configuratorValidator.service';
import {ConfiguratorWorkflowService} from './configuratorWorkflow.service';
import {ConfiguratorScheduleService} from './configuratorSchedule.service';
import {EngineCampaignService} from './engineCampaign.service';
import {EngineCampaignGroupService} from './engineCampaignGroup.service';
import {EngineDataQueryService} from './engineDataQuery.service';
import {EngineEtlService} from './engineEtl.service';
import {EngineLandingPageService} from './engineLandingPage.service';
import {EnginePingService} from './enginePing.service';
import {EnginePublicDownloadService} from './enginePublicDownload.service';
import {EnginePublicLandingPageService} from './enginePublicLandingPage.service';
import {EnginePublicPersonalService} from './enginePublicPersonal.service';
import {EnginePublicUpdateService} from './enginePublicUpdate.service';
import {EngineQueryService} from './engineQuery.service';
import {EngineRgpdService} from './engineRgpd.service';
import {EngineScriptService} from './engineScript.service';
import {EngineSearchInvoiceService} from './engineSearchInvoice.service';
import {EngineSqlService} from './engineSql.service';
import {EngineStatisticsService} from './engineStatistics.service';
import {EngineStructureService} from './engineStructure.service';
import {EngineTransactionalEmailService} from './engineTransactionalEmail.service';
import {EngineWebHookService} from './engineWebHook.service';
import {EngineWorkflowService} from './engineWorkflow.service';
import {EngineTagEventPersonalService} from './engineTagEventPersonal.service';
import {EngineTagEventService} from './engineTagEvent.service';
import {EngineTagService} from './engineTag.service';
import {EngineSharedFileService} from './engineSharedFile.service';
import {EngineScenarioService} from './engineScenario.service';
import {ConfiguratorPublicI18nCacheService} from './configuratorPublicI18nCache.service';
import {GatewayPublicUserService} from './gatewayPublicUser.service';
import {GatewayRoleResourceService} from './gatewayRoleResource.service';
import {GatewayLogoutResourceService} from './gatewayLogoutResource.service';
import {GatewayAccountService} from './gatewayAccount.service';
import {ActivityTypeEnum, GatewayUserActivityService} from './gatewayUserActivity.service';
// Engine
export * from './engineCampaign.service';
export * from './engineCampaignGroup.service';
export * from './engineDataQuery.service';
export * from './engineEtl.service';
export * from './engineLandingPage.service';
export * from './enginePublicDownload.service';
export * from './enginePublicLandingPage.service';
export * from './enginePublicPersonal.service';
export * from './enginePublicUpdate.service';
export * from './engineQuery.service';
export * from './engineRgpd.service';
export * from './engineScript.service';
export * from './engineSearchInvoice.service';
export * from './engineStatistics.service';
export * from './engineStructure.service';
export * from './engineTransactionalEmail.service';
export * from './engineWebHook.service';
export * from './engineWorkflow.service';
export * from './engineTag.service';
export * from './engineTagEvent.service';
export * from './engineTagEventPersonal.service';
export * from './engineSharedFile.service';
export * from './engineScenario.service';

// tslint:disable-next-line:max-line-length
export const APISEngine = [EngineScenarioService, EngineSharedFileService, EngineTagService, EngineTagEventService, EngineTagEventPersonalService, EngineCampaignService, EngineCampaignGroupService, EnginePingService, EnginePublicUpdateService, EngineSqlService, EngineStructureService, EngineLandingPageService, EngineStatisticsService, EngineSearchInvoiceService, EnginePublicDownloadService, EngineDataQueryService, EngineWorkflowService, EnginePublicPersonalService, EngineQueryService, EngineEtlService, EnginePublicLandingPageService, EngineRgpdService, EngineScriptService, EngineTransactionalEmailService, EngineWebHookService];

// configurator
export * from './configuratorCallInvoices.service';
export * from './configuratorCommandOrder.service';
export * from './configuratorConfiguration.service';
export * from './configuratorContact.service';
export * from './configuratorCompany.service';
export * from './configuratorDataView.service';
export * from './configuratorDatastore.service';
export * from './configuratorEtl.service';
export * from './configuratorI18n.service';
export * from './configuratorI18nCache.service';
export * from './configuratorLandingPage.service';
export * from './configuratorNewsletter.service';
export * from './configuratorPageHtml5.service';
export * from './configuratorPing.service';
export * from './configuratorProvider.service';
export * from './configuratorPublicLandingPage.service';
export * from './configuratorPublicNewsletter.service';
export * from './configuratorPublicUpdate.service';
export * from './configuratorSaveQuery.service';
export * from './configuratorUserUiPreference.service';
export * from './configuratorScenario.service';
export * from './configuratorScript.service';
export * from './configuratorSendInBlue.service';
export * from './configuratorStatisticsCache.service';
export * from './configuratorStructure.service';
export * from './configuratorTable.service';
export * from './configuratorTask.service';
export * from './configuratorTemplateHtml.service';
export * from './configuratorTenant.service';
export * from './configuratorFileConnection.service';
export * from './configuratorTenantConfiguration.service';
export * from './configuratorToken.service';
export * from './configuratorTraduction.service';
export * from './configuratorTransactionalEmail.service';
export * from './configuratorValidator.service';
export * from './configuratorWorkflow.service';
export * from './configuratorPublicI18nCache.service';
export * from './configuratorSchedule.service';


// tslint:disable-next-line:max-line-length
export const APISConf = [ConfiguratorFileConnectionService, ConfiguratorCompanyService, ConfiguratorScheduleService, ConfiguratorPublicI18nCacheService, ConfiguratorStructureService, ConfiguratorPublicUpdateService, ConfiguratorStatisticsCacheService, ConfiguratorStructureService, ConfiguratorTenantConfigurationService, ConfiguratorTraductionService, ConfiguratorPingService, ConfiguratorI18nCacheService, ConfiguratorValidatorService, ConfiguratorCallInvoicesService, ConfiguratorSaveQueryService, ConfiguratorUserUiPreferenceService, ConfiguratorTaskService, ConfiguratorProviderService, ConfiguratorContactService, ConfiguratorI18nService, ConfiguratorCommandOrderService, ConfiguratorPublicNewsletterService, ConfiguratorTokenService, ConfiguratorDataViewService, ConfiguratorDatastoreService, ConfiguratorEtlService, ConfiguratorLandingPageService, ConfiguratorPageHtml5Service, ConfiguratorPublicLandingPageService, ConfiguratorScriptService, ConfiguratorSendInBlueService, ConfiguratorTableService, ConfiguratorTemplateHtmlService, ConfiguratorTenantService, ConfiguratorTransactionalEmailService, ConfiguratorWorkflowService, ConfiguratorNewsletterService, ConfiguratorConfigurationService, ConfiguratorScenarioService];

export * from './gatewayPublicUser.service';
export * from './gatewayRoleResource.service';
export * from './gatewayLogoutResource.service';
export * from './gatewayAccount.service';
export * from './gatewayUserActivity.service';
// tslint:disable-next-line:max-line-length
export const APISGateway = [ActivityTypeEnum, GatewayUserActivityService, GatewayAccountService, GatewayLogoutResourceService, GatewayRoleResourceService, GatewayPublicUserService];

// Others
export * from './cache-js.service';


export const othersApi = [CacheJsService];
//
export const APIS = [...APISGateway, ...APISEngine, ...APISConf, ...othersApi];

